import { useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { getTeacher } from "services/teacherService";
import { getClassTasks } from "services/classTaskService";
import { getAllLeaves, LeaveSearchParams, updateLeave } from "services/leaveService";
import { Leave, LeaveUpdate } from "types/leaveTypes";
import { fetchClassSubjects } from "services/classSubjectService";
import { ClassForTeacher } from "types/classTaskTypes";

export const useTeacher = () => {
  const { t } = useTranslation();
  const [teacher, setTeacher] = useState<any | null>(null);
  const [tasks, setTasks] = useState<any | null>(null);
  const [classes, setClasses] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const [leaves, setLeaves] = useState<Leave[]>([]);
  const [infoPagination, setInfoPagination] = useState<any>({ page: 1, limit: 10, total: 0 });


  const fetchTeacherById = async (teacherId: string) => {
    setLoading(true);
    try {
      const response = await getTeacher(teacherId);
      setTeacher(response?.data || null);
      return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const fetchTasksTeacher = async (teacherId: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await getClassTasks({ teacherId });
      setTasks(response.data || []);
      return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const fetchTeacherLeaves = async (filters: LeaveSearchParams) => {
    setLoading(true);
    try {
      const response = await getAllLeaves(filters);
      setLeaves(response.data);
      setInfoPagination(response.pagination);
      setError(null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const handleUpdateStatusLeaveTeacher = async (leaveId: string, payload: LeaveUpdate) => {
    try {
      await updateLeave(leaveId, payload);
      message.success(t("leave.success_update"));
      // await fetchTeacherLeaves({ staffId: teacher?.staff?.id, page: 1, limit: 10 });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const fetchClassesTeacher = async (teacherId: string) => {
    try {
      setLoading(true);
      const response = await fetchClassSubjects({ teacherIds: [teacherId] });
      const typedResponse = response as ClassForTeacher[];
      const allClasses = typedResponse[0]?.classes ?? [];
      setClasses(allClasses);
      return true
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    teacher,
    loading,
    error,
    fetchTeacherById,
    fetchTasksTeacher,
    tasks,
    leaves,
    infoPagination,
    fetchTeacherLeaves,
    handleUpdateStatusLeaveTeacher,
    fetchClassesTeacher,
    classes
  };
};

export default useTeacher;
